import React from 'react'
import { Box, SxProps, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useTheme } from '@mui/styles'
import ThemeInterface from '@/theme-interface'

type Props = {
  title: string
  children: React.ReactNode
  sx?: SxProps
}

const Info = ({ title, children, sx }: Props) => {
  const theme = useTheme<ThemeInterface>()

  return (
    <Box
      display='grid'
      gridTemplateColumns='auto 1fr'
      gap={1}
      bgcolor='info.background'
      borderRadius={1}
      p={1}
      sx={sx}
    >
      <InfoOutlinedIcon fontSize='medium' color='info' sx={{ alignSelf: 'center' }} />
      <Typography fontWeight={theme.fontWeights.bold}>{title}</Typography>
      <Box gridColumn={2} display='flex' flexDirection='column' color='lightBlue.800'>
        {children}
      </Box>
    </Box>
  )
}

export default Info
